// Корректирую пришедшие данные (удаляю всё ненужное и убираю лишнюю вложенность)

import moment from "moment";

const parseAssignment = arr => {
  let result = [];
  arr.forEach(obj => {
    const { assignmentId } = obj;
    result.push(assignmentId);
  });
  return result;
};

export const adjustUpdateVehicleStatusResponse = vehicle => {
  let name = "";
  if (vehicle.vehicleModelId) {
    const { modelName } = vehicle.vehicleModelId;
    const { brandName } =
      vehicle.vehicleModelId.vehicleBrandId &&
      vehicle.vehicleModelId.vehicleBrandId.brandKey;
    name += brandName ? brandName + " " : "";
    name += modelName ? modelName + " " : "";
  }
  name += ` ${vehicle.registerSign ? vehicle.registerSign : ""}${
    vehicle.registerRegion ? " " + vehicle.registerRegion : ""
  }`;
  return {
    vehicleId: vehicle.vehicleId,
    name,
    statusKey:
      vehicle.vehicleStatusId && vehicle.vehicleStatusId.vehicleStatusKey,
    status: vehicle.vehicleStatusId && vehicle.vehicleStatusId.vehicleStatus
  };
};

export const dataAdjustmentCardResponse = vehicleById => {
  const assignment =
    vehicleById.assignment &&
    vehicleById.assignment.length &&
    parseAssignment(vehicleById.assignment);
  return {
    ...vehicleById, // todo после завершения удалить ...vehicleById
    brand:
      vehicleById.vehicleModelId &&
      vehicleById.vehicleModelId.vehicleBrandId &&
      vehicleById.vehicleModelId.vehicleBrandId.vehicleBrandId,
    brandName:
      vehicleById.vehicleModelId &&
      vehicleById.vehicleModelId.vehicleBrandId &&
      vehicleById.vehicleModelId.vehicleBrandId.brandName,
    model:
      vehicleById.vehicleModelId && vehicleById.vehicleModelId.vehicleModelId,
    vin: vehicleById.vin,
    registerSign: vehicleById.registerSign,
    registerRegion: vehicleById.registerRegion,
    registerSignAndRegion: `${vehicleById.registerSign}${
      vehicleById.registerRegion ? vehicleById.registerRegion : ""
    }`,
    vehicleType:
      vehicleById.vehicleTypeId && vehicleById.vehicleTypeId.vehicleTypeId,
    productionYear: vehicleById.productionYear,
    category:
      vehicleById.vehicleCategoryId &&
      vehicleById.vehicleCategoryId.vehicleCategoryId,
    osagoNum: vehicleById.osagoNum,
    osagoValidUntilDate: vehicleById.osagoValidUntil,
    color:
      vehicleById.vehicleColorId && vehicleById.vehicleColorId.vehicleColorId
        ? vehicleById.vehicleColorId.vehicleColorId
        : vehicleById.vehicleColorId
        ? vehicleById.vehicleColorId
        : undefined,
    steeringArrangement:
      vehicleById.vehicleSteeringArrangementId &&
      vehicleById.vehicleSteeringArrangementId.vehicleSteeringArrangementId
        ? vehicleById.vehicleSteeringArrangementId.vehicleSteeringArrangementId
        : vehicleById.vehicleSteeringArrangementId
        ? vehicleById.vehicleSteeringArrangementId
        : undefined,
    driveUnitType:
      vehicleById.vehicleDriveUnitTypeId &&
      vehicleById.vehicleDriveUnitTypeId.vehicleDriveUnitTypeId
        ? vehicleById.vehicleDriveUnitTypeId.vehicleDriveUnitTypeId
        : vehicleById.vehicleDriveUnitTypeId
        ? vehicleById.vehicleDriveUnitTypeId
        : undefined,
    engineTypeName:
      vehicleById.vehicleEngineTypeId &&
      vehicleById.vehicleEngineTypeId.vehicleEngineTypeId
        ? vehicleById.vehicleEngineTypeId.vehicleEngineTypeId
        : vehicleById.vehicleEngineTypeId
        ? vehicleById.vehicleEngineTypeId
        : undefined,
    engineVolume: vehicleById.engineVolume,
    engineCapacity: vehicleById.engineCapacity,
    vehicleWeight: vehicleById.vehicleWeight,
    vehicleMaxWeight: vehicleById.vehicleMaxWeight,
    passengerCapacity: vehicleById.passengerCapacity,
    doorsAmount: vehicleById.doorsAmount,
    garageNum: vehicleById.garageNum,
    tachograph:
      vehicleById.tachograph &&
      Array.isArray(vehicleById.tachograph) &&
      vehicleById.tachograph.map(item => item.tachographKey),
    restrictionsServiceTypes:
      vehicleById.serviceTypes &&
      Array.isArray(vehicleById.serviceTypes) &&
      vehicleById.serviceTypes.map(item => item.serviceTypeKey),
    fixedDrivers:
      vehicleById.profilesPinned &&
      Array.isArray(vehicleById.profilesPinned) &&
      vehicleById.profilesPinned.map(item => item.profileId),
    gps: vehicleById.gps || undefined,
    diagnosticCardNum: vehicleById.diagnosticCardNum,
    diagnosticCardValidUntilDate: vehicleById.diagnosticCardValidUntil,
    contractOsgoppNum: vehicleById.contractOsgoppNum,
    contractOsgoppValidUntilDate: vehicleById.contractOsgoppValidUntil,
    kaskoNum: vehicleById.kaskoNum,
    kaskoValidUntilDate: vehicleById.kaskoValidUntil,
    conditioner:
      vehicleById.vehicleConditionerId &&
      vehicleById.vehicleConditionerId.vehicleConditionerId,
    tint: vehicleById.vehicleTintId && vehicleById.vehicleTintId.vehicleTintId,
    parkingAddress:
      vehicleById.vehicleParkingAddressId &&
      vehicleById.vehicleParkingAddressId.vehicleParkingAddressId,
    luggageCapacity: vehicleById.luggageCapacity,
    monetizationNeed: vehicleById.monetizationNeed === 0,
    archivedAt: vehicleById.updatedAt, // todo заменить на archivedAt
    //vehicle_seat_material_id

    photo1: vehicleById.photo1 || null,
    photo2: vehicleById.photo2 || null,
    photo3: vehicleById.photo3 || null,
    photo4: vehicleById.photo4 || null,
    photo5: vehicleById.photo5 || null,
    photo6: vehicleById.photo6 || null,
    photo7: vehicleById.photo7 || null,
    photo8: vehicleById.photo8 || null,
    photo9: vehicleById.photo9 || null,
    photo10: vehicleById.photo10 || null,
    photoFrontSts: vehicleById.photoFrontSts || null,
    photoBackSts: vehicleById.photoBackSts || null,
    photoFrontPts: vehicleById.photoFrontPts || null,
    photoBackPts: vehicleById.photoBackPts || null,
    license_transportation_num: vehicleById.licenseTransportationNum || null,
    license_transportation_date:
      (vehicleById.licenseTransportationDate &&
        moment(vehicleById.licenseTransportationDate)) ||
      null,
    license_author: vehicleById.licenseAuthor || null,
    assignment,
    vehicleStatusKey:
      vehicleById.vehicleStatusId &&
      vehicleById.vehicleStatusId.vehicleStatusKey
  };
};

// Корректирую данные для отправки
export const dataUpdateVehicleRequest = data => {
  // console.log('до обработки', data);
  let newData = { vehicle: {} };

  if (data.license_transportation_num) {
    newData.vehicle["license_transportation_num"] =
      data.license_transportation_num;
  }
  if (data.license_transportation_date) {
    newData.vehicle["license_transportation_date"] = moment(
      data.license_transportation_date
    ).format("YYYY-MM-DD");
  }
  if (data.license_author) {
    newData.vehicle["license_author"] = data.license_author;
  }
  if (data.contractOsgoppNum)
    newData.vehicle.contract_osgopp_num = data.contractOsgoppNum;
  if (data.diagnosticCardNum)
    newData.vehicle.diagnostic_card_num = data.diagnosticCardNum;
  if (data.doorsAmount) newData.vehicle.doors_amount = data.doorsAmount;
  if (data.engineCapacity)
    newData.vehicle.engine_capacity = data.engineCapacity;
  if (data.engineVolume) newData.vehicle.engine_volume = data.engineVolume;
  if (data.garageNum) newData.vehicle.garage_num = data.garageNum;
  if (data.gps) newData.vehicle.gps = data.gps;
  if (data.kaskoNum) newData.vehicle.kasko_num = data.kaskoNum;
  if (data.luggageCapacity)
    newData.vehicle.luggage_capacity = data.luggageCapacity;
  if (data.monetizationNeed)
    newData.vehicle.monetization_need = data.monetizationNeed;
  if (data.osagoNum) newData.vehicle.osago_num = data.osagoNum;
  if (data.passengerCapacity)
    newData.vehicle.passenger_capacity = data.passengerCapacity;
  if (data.productionYear)
    newData.vehicle.production_year = data.productionYear;
  if (data.registerSignAndRegion) {
    data.registerSignAndRegion = data.registerSignAndRegion
      .replace(/\s/g, "")
      .toUpperCase();
    newData.vehicle.register_sign = data.registerSignAndRegion.substr(0, 6);
    newData.vehicle.register_region =
      data.registerSignAndRegion.length > 6
        ? data.registerSignAndRegion.slice(6)
        : "";
  }
  if (data.category) newData.vehicle.vehicle_category_id = data.category;
  if (data.color) newData.vehicle.vehicle_color_id = data.color;
  if (data.conditioner)
    newData.vehicle.vehicle_conditioner_id = data.conditioner;
  if (data.driveUnitType)
    newData.vehicle.vehicle_drive_unit_type_id = data.driveUnitType;
  if (data.engineTypeName)
    newData.vehicle.vehicle_engine_type_id = data.engineTypeName;
  if (data.vehicleMaxWeight)
    newData.vehicle.vehicle_max_weight = data.vehicleMaxWeight;
  if (data.vehicleWeight) newData.vehicle.vehicle_weight = data.vehicleWeight;
  if (data.model) newData.vehicle.vehicle_model_id = data.model;
  if (data.parkingAddress)
    newData.vehicle.vehicle_parking_address_id = data.parkingAddress;
  // vehicle_seat_material_id:
  if (data.steeringArrangement)
    newData.vehicle.vehicle_steering_arrangement_id = data.steeringArrangement;
  if (data.vin) newData.vehicle.vin = data.vin;
  if (data.tint) newData.vehicle.vehicle_tint_id = data.tint;

  if (data.contractOsgoppValidUntilDate) {
    newData.vehicle.contract_osgopp_valid_until =
      typeof data.contractOsgoppValidUntilDate === "string"
        ? data.contractOsgoppValidUntilDate
        : data.contractOsgoppValidUntilDate.format("YYYY-MM-DD");
  }
  if (data.diagnosticCardValidUntilDate) {
    newData.vehicle.diagnostic_card_valid_until =
      typeof data.diagnosticCardValidUntilDate === "string"
        ? data.diagnosticCardValidUntilDate
        : data.diagnosticCardValidUntilDate.format("YYYY-MM-DD");
  }
  if (data.kaskoValidUntilDate) {
    newData.vehicle.kasko_valid_until =
      typeof data.kaskoValidUntilDate === "string"
        ? data.kaskoValidUntilDate
        : data.kaskoValidUntilDate.format("YYYY-MM-DD");
  }
  if (data.osagoValidUntilDate) {
    newData.vehicle.osago_valid_until =
      typeof data.osagoValidUntilDate === "string"
        ? data.osagoValidUntilDate
        : data.osagoValidUntilDate.format("YYYY-MM-DD");
  }

  if (data.tachograph) {
    newData.tachograph_keys = data.tachograph;
  }
  if (data.restrictionsServiceTypes) {
    newData.service_type_keys = data.restrictionsServiceTypes;
  }
  if (data.restrictionsServiceTypes) {
    newData.service_type_keys = data.restrictionsServiceTypes;
  }
  if (data.fixedDrivers && data.fixedDrivers.length) {
    newData.profile_pin_ids = data.fixedDrivers;
  }
  // service_type_keys
  if (data.vehicleType) {
    newData.vehicle.vehicle_type_id = data.vehicleType;
  }
  /*
    "company_id": 1,
  */
  if (data.photo1) {
    newData.vehicle["photo1"] = data.photo1;
  }
  if (data.photo2) {
    newData.vehicle["photo2"] = data.photo2;
  }
  if (data.photo3) {
    newData.vehicle["photo3"] = data.photo3;
  }
  if (data.photo4) {
    newData.vehicle["photo4"] = data.photo4;
  }
  if (data.photo5) {
    newData.vehicle["photo5"] = data.photo5;
  }
  if (data.photo6) {
    newData.vehicle["photo6"] = data.photo6;
  }
  if (data.photo7) {
    newData.vehicle["photo7"] = data.photo7;
  }
  if (data.photo8) {
    newData.vehicle["photo8"] = data.photo8;
  }
  if (data.photo9) {
    newData.vehicle["photo9"] = data.photo9;
  }
  if (data.photo10) {
    newData.vehicle["photo10"] = data.photo10;
  }

  if (data.photoFrontSts) {
    newData.vehicle["photo_front_sts"] = data.photoFrontSts;
  }
  if (data.photoBackSts) {
    newData.vehicle["photo_back_sts"] = data.photoBackSts;
  }
  if (data.photoFrontPts) {
    newData.vehicle["photo_front_pts"] = data.photoFrontPts;
  }
  if (data.photoBackPts) {
    newData.vehicle["photo_back_pts"] = data.photoBackPts;
  }

  // console.log(data, newData);
  return newData;
};

export const vehicleErrorResponse = data => {
  let newData = {};
  if (data && data.errors) {
    Object.keys(data.errors).map(
      (key, index) => (newData[key] = data.errors[key][0])
    );
    /*
    const err = data.errors;
    if (err.order) {
      if (err.order.order_status_key) {
        newData.orderStatus = err.order.order_status_key;
      }
    }
    */
  }
  return newData;
};

//парсит Марку и Модель В автоопределении
const vehicleBrandAndModel = (string, brand) => {
  let arrString = string.split(" ");
  if (brand) {
    return arrString[0] ? arrString[0] : "";
  } else {
    const [, ...model] = arrString;
    return model.join("");
  }
};

export const dataAdjustmentSearchAutoResponse = data => {
  if (
    data &&
    data.state === "ok" &&
    data.data &&
    data.data[0] &&
    data.data[0].content &&
    data.data[0].content.techData
  ) {
    const { techData } = data.data[0].content;
    if (techData) {
      let newData = {};
      if (
        techData.brand &&
        techData.brand.name &&
        techData.brand.name.original
      ) {
        newData.brandName = vehicleBrandAndModel(
          techData.brand.name.original,
          true
        );
        newData.modelName = vehicleBrandAndModel(
          techData.brand.name.original,
          false
        );
      }
      if (techData.year) {
        newData.productionYear = techData.year;
      }
      if (
        data.data[0].content.additionalInfo &&
        data.data[0].content.additionalInfo.vehicle &&
        data.data[0].content.additionalInfo.vehicle.category &&
        data.data[0].content.additionalInfo.vehicle.category.code
      ) {
        newData.categoryName =
          data.data[0].content.additionalInfo.vehicle.category.code;
      }
      if (techData.body && techData.body.color && techData.body.color.name) {
        newData.colorName = techData.body.color.name;
      }
      if (techData.engine) {
        if (techData.engine.fuel && techData.engine.fuel.type) {
          if (techData.engine.fuel.type.indexOf("Бензин") !== -1) {
            newData.engineTypeName = 1; // todo заменить везде на engineType, так как тут Id а не Name
          } else if (techData.engine.fuel.type.indexOf("Дизель") !== -1) {
            newData.engineTypeName = 2;
          }
        }
        if (techData.engine.volume) {
          newData.engineVolume = techData.engine.volume;
        }
        if (techData.engine.power && techData.engine.power.hp) {
          newData.engineCapacity = techData.engine.power.hp;
        } // 100.61
        // if(techData.engine.power && techData.engine.power.kw) { newData.engineCapacity = techData.engine.power.kw; } // 74
      }
      if (techData.weight) {
        if (techData.weight.netto) {
          newData.vehicleWeight = techData.weight.netto;
        }
        if (techData.weight.max) {
          newData.vehicleMaxWeight = techData.weight.max;
        }
      }
      if (techData.wheel && techData.wheel.position) {
        newData.steeringArrangement =
          techData.wheel.position === "LEFT" ? 1 : 2;
      }
      if (techData.drive && techData.drive.type) {
        if (techData.drive.type.indexOf("Заднепривод") !== -1) {
          techData.driveUnitType = 1;
        } else if (techData.drive.type.indexOf("Переднепривод") !== -1) {
          techData.driveUnitType = 2;
        } else if (techData.drive.type.indexOf("Полнопривод") !== -1) {
          techData.driveUnitType = 3;
        }
      }
      if (techData.type && techData.type.name) {
        newData.vehicleTypeName = techData.vehicleTypeName = techData.type.name;
      }
      return newData;
    }
  }
  return {};
};
